module.exports = __webpack_public_path__ + "static/mindcop-6bf6bf2832f1ed22575d051474c35972.webp";